import { PURGE_DATA } from './timer';

const UPDATE_PAIRS = '@@checkout/security/update_pairs';

const initialState = {
  question1: '',
  question2: '',
  question3: '',
  question4: '',
  question5: '',
};

const form = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAIRS: {
      return {
        ...state,
        ...action.pairs,
      };
    }
    case PURGE_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};

export const updatePairs = pairs => ({
  type: UPDATE_PAIRS,
  pairs,
});

export default form;
